export const USER = 'mkimbrou';
export const PASS = 'nspadmin';
export const TOKEN = 'qjCbex522DfVEVd5ysUWppWQ';